import type { MarketFlowData, VisualizationConfig } from '../types/market'

export type RenderMode = 'preview' | 'noon' | 'close'

export interface RenderContext {
  mode: RenderMode
  title: string
  marketMinuteDuration: number
  data: MarketFlowData
}

function isMorningTime(time: string): boolean {
  return time >= '09:30' && time <= '11:30'
}

function isAfternoonTime(time: string): boolean {
  return time >= '13:00' && time <= '15:00'
}

export function parseRenderMode(value: string | null | undefined): RenderMode {
  return value === 'noon' || value === 'close' ? value : 'preview'
}

export function createRenderContext(
  mode: RenderMode,
  source: MarketFlowData,
  config: VisualizationConfig,
): RenderContext {
  if (mode === 'noon') {
    return {
      mode,
      title: '全市场午盘资金流向',
      marketMinuteDuration: config.noonMarketMinuteDuration,
      data: { ...source, frames: source.frames.filter((frame) => isMorningTime(frame.time)) },
    }
  }
  if (mode === 'close') {
    return {
      mode,
      title: '全市场收盘资金流向',
      marketMinuteDuration: config.closeMarketMinuteDuration,
      data: {
        ...source,
        frames: source.frames.filter((frame) => isMorningTime(frame.time) || isAfternoonTime(frame.time)),
      },
    }
  }
  return {
    mode,
    title: '全市场资金流向',
    marketMinuteDuration: config.marketMinuteDuration,
    data: source,
  }
}
